import { useState } from "react";
import { motion } from "framer-motion";

// Full-screen entry splash. Until the visitor confirms they're 18+, NONE of the
// app (navbar, routes, home content) is mounted — the splash fully replaces it.
export default function AgeGate({ children }) {
  const [confirmed, setConfirmed] = useState(() => {
    try {
      return !!localStorage.getItem("velluto_age_ok");
    } catch {
      return false;
    }
  });

  if (confirmed) return children;

  const confirm = () => {
    try {
      localStorage.setItem("velluto_age_ok", "1");
    } catch { /* ignore */ }
    setConfirmed(true);
  };

  return (
    <div
      data-testid="age-gate"
      className="fixed inset-0 z-[10000] flex flex-col items-center justify-center bg-ink px-6 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-40 bg-[radial-gradient(circle_at_50%_25%,rgba(114,47,55,0.55),transparent_62%)]" />
      <div className="absolute inset-x-0 top-0 flex justify-center pt-10">
        <span className="brand-script text-6xl sm:text-7xl">Velluto</span>
      </div>

      <motion.div
        initial={{ y: 24, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ delay: 0.1, duration: 0.8 }}
        className="relative z-10 max-w-lg text-center"
      >
        <p className="text-xs uppercase tracking-[0.4em] text-gold mb-8">Private members only</p>
        <h1 className="font-display text-5xl sm:text-6xl font-light leading-none mb-6">
          You are entering<br />
          <span className="italic">a private space.</span>
        </h1>
        <p className="text-text-muted text-sm leading-relaxed mb-10 max-w-md mx-auto">
          Velluto is an adults-only community for consenting connections. By entering,
          you confirm you are at least 18 years of age and consent to mature themes.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <button
            data-testid="age-gate-confirm"
            onClick={confirm}
            className="px-10 py-4 bg-wine hover:bg-wine-hover transition-colors text-sm uppercase tracking-[0.2em] rounded-full"
          >
            I am 18 or older — Enter
          </button>
          <a
            href="https://www.google.com"
            className="px-10 py-4 border border-white/15 hover:border-white/30 transition-colors text-sm uppercase tracking-[0.2em] rounded-full text-text-muted"
          >
            Leave
          </a>
        </div>
      </motion.div>

      <p className="absolute inset-x-0 bottom-8 text-center text-[11px] uppercase tracking-[0.25em] text-text-muted/60">
        Discreet · Consensual · 18+
      </p>
    </div>
  );
}
